import { Ref, useRef, useState } from 'react';
import { Tooltip, TextCutter, TextCutterProps } from '@anytag/shared-atoms';
import { useDeepCompareEffect, useDimensions } from '@anytag/shared-hooks';
import { cn } from '@anytag/shared-utils';
import { InfluencerTagsPopover } from './InfluencerTagsPopover';

export interface TagsSectionProps {
  tags: readonly string[];
  className?: string;
  influencerId: number;
}

export const TagsSection = ({ influencerId, tags, className }: TagsSectionProps) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const { height } = useDimensions(ref);
  const [tagsValue, setTagsValue] = useState(tags);

  useDeepCompareEffect(() => {
    setTagsValue(tags);
  }, [tags]);

  const defaultHeight = 63; // 2 lines
  const hasTags = !!tagsValue.length;

  const Tags = ({
    lines,
    ref,
    className
  }: Pick<TextCutterProps, 'lines'> & { ref?: Ref<HTMLParagraphElement>; className?: string }) => (
    <TextCutter
      ref={ref}
      lines={lines}
      className={cn('m-[-4px]', className)}
      text={tagsValue.map((tag, index) => (
        <span key={`${influencerId}-${index}`} className="inline-flex p-1">
          <span className="relative max-w-60 overflow-hidden rounded-sm bg-black-20 px-2 py-1 text-sm text-ellipsis whitespace-nowrap">
            {tag}
          </span>
        </span>
      ))}
    />
  );

  return (
    <div className={cn('flex w-60 items-center', className)}>
      <InfluencerTagsPopover
        tags={tagsValue}
        onTagsChange={setTagsValue}
        influencerId={influencerId}
        target={({ setOpen }) =>
          tagsValue.length ? (
            <Tooltip
              help={height > defaultHeight ? <Tags lines={5} className="max-w-50 text-primary" /> : ''}
              noArrow
              className="bg-white shadow-strong"
            >
              <div ref={ref} className="pseudo-hover" onClick={() => (hasTags ? setOpen() : null)}>
                <Tags lines={height > defaultHeight ? 2 : 3} />
              </div>
            </Tooltip>
          ) : undefined
        }
      />
    </div>
  );
};
